<template>
  <v-row>
    <v-col>
      <v-col
        class="d-flex justify-space-between mx-auto py-5 flex-wrap container"
      >
        <ToolbarTitles :title="title" />
      </v-col>
      <div class="container">
        <TableWithSearch
          :items="getPcasRelations"
          :headers="allHeaders"
          :openDialog="openDialog"
          :showPagination="false"
          @headersUpdated="updateHeaders"
          :pcas="true"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>

      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset()"
      >
        <FormOrder
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          @itemUpdate="dataSelectUpdate"
        />
      </v-dialog>
      <Snackbar
        :alert="showSnackbar"
        :textAlert="textSnackbar"
        :color="colorSnackbar"
      />
    </v-col>
  </v-row>
</template>
<script>
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import pcas from "@/store/pcas/pcas";
import FormOrder from "@/components/Complement/FormOrder.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  name: "Reports",
  components: {
    ToolbarTitles,
    TableWithSearch,
    FormOrder,
    Snackbar,
  },
  data() {
    return {
      buttonSelected: 0,
      title: this.$tc("nav.pcas"),
      mode: "",
      headers: [
        {
          text: "Nombre",
          value: "pcaName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "pcaDescription",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Roles",
          value: "roles",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      open: false,
      openDelete: false,
      showDelete: false,
      itemDelete: null,
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "",
      key: 0,
      formValid: false,
    };
  },
  mounted() {
    pcas.dispatch("getPcasRelations");
    pcas.dispatch("getPcas");
    pcas.dispatch("getRoles");

    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },
  computed: {
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getPcasRelations() {
      return pcas.state.pcasRelations;
    },
    getPcas() {
      return pcas.state.pcas ? pcas.state.pcas : [];
    },
    getAllRoles() {
      return pcas.state.roles ? pcas.state.roles : [];
    },
    parameters() {
      if (this.mode == this.$tc("pcas.addRelationPcas")) {
        return {
          items: [
            {
              id: 1,
              show: true,
              data: "",
              name: "pcaId",
              type: "select",
              label: this.$tc("pcas.labelPcas"),
              items: this.getPcas,
              itemText: "name",
              itemValue: "pcaId",
              rules: [
                (v) =>
                  (v !== null && v !== undefined && v !== "") ||
                  this.$tc("editRegistrations.requerid"),
              ],
              order: 1,
            },
            {
              id: 2,
              show: true,
              data: "",
              name: "rolId",
              type: "select",
              label: this.$tc("pcas.labelRol"),
              items: [],
              itemText: "name",
              itemValue: "rolId",
              rules: [
                (v) =>
                  (v !== null && v !== undefined && v !== "") ||
                  this.$tc("editRegistrations.requerid"),
              ],
              order: 2,
              multiple: true,
              disabled: true,
            },
          ],
        };
      } else {
        return {
          items: [
            {
              id: 1,
              show: true,
              data: "",
              name: "pcaId",
              type: "select",
              label: this.$tc("pcas.labelPcas"),
              items: [],
              itemText: "pcaName",
              itemValue: "pcaId",
              rules: [
                (v) =>
                  (v !== null && v !== undefined && v !== "") ||
                  this.$tc("editRegistrations.requerid"),
              ],
              order: 1,
            },
            {
              id: 2,
              show: true,
              data: "",
              name: "rolId",
              type: "select",
              label: this.$tc("pcas.labelRol"),
              items: [],
              itemText: "rolNombre",
              itemValue: "rolId",
              rules: [
                (v) =>
                  (v !== null && v !== undefined && v !== "") ||
                  this.$tc("editRegistrations.requerid"),
              ],
              order: 2,
              disabled: true,
            },
          ],
        };
      }
    },
  },

  methods: {
    async refreshItems() {
      await pcas.dispatch("getPcasRelations");
    },
    openDialog(type, item) {
      this.open = true;
      switch (type) {
        case "add":
          this.mode = this.$tc("pcas.addRelationPcas");
          break;
        case "delete":
          this.mode = this.$tc("pcas.deleteAttribute");
          this.parameters.items[0].data = item.pcaId;
          this.parameters.items[0].disabled = true;
          this.parameters.items[0].items = [item];
          this.parameters.items[1].items = this.getRoles(item.pcaId);
          this.parameters.items[1].disabled = false;

          break;
        default:
          break;
      }
    },
    dataSelectUpdate(item) {
      if (item.name === "pcaId") {
        if (this.mode == this.$tc("pcas.addRelationPcas")) {
          this.parameters.items[1].items = this.getRolesFilter(item.data);
          this.parameters.items[1].disabled = false;
        } else {
          this.parameters.items[1].items = this.getRoles(item.data);
          this.parameters.items[1].disabled = false;
        }
      }
    },
    getRolesFilter(idPca) {
      let rolesPcaId = pcas.state.pcasRelations.find(
        (pcaItem) => pcaItem.pcaId === idPca
      );
      if (!rolesPcaId) {
        return this.getAllRoles;
      }
      let filterRol = pcas.state.roles.filter(
        (role) =>
          !rolesPcaId.roles.some(
            (relationRole) => relationRole.rolId === role.rolId
          )
      );
      return filterRol;
    },
    getRoles(idPca) {
      let rolesPcaId = pcas.state.pcasRelations.find(
        (pcaItem) => pcaItem.pcaId === idPca
      );
      if (!rolesPcaId) {
        return [];
      }
      return rolesPcaId.roles;
    },
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allHeaders;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0 ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm(item) {
      const pcaId = parseInt(item.pcaId, 10);
      const roles = item.rolId.split(",").map((id) => parseInt(id, 10));
      const data = {
        pcaId: pcaId,
        roles: roles,
      };
      if (this.mode == this.$tc("pcas.addRelationPcas")) {
        pcas.commit("setNewRelations", data);
        pcas.dispatch("addRelation").then(() => {
          this.alert(this.$tc("pcas.addSuccess"), "primary", true);
        });
      } else {
        pcas.commit("setDelRelations", data);
        pcas.dispatch("deleteRelation").then(() => {
          this.alert(this.$tc("pcas.deleteSuccess"), "primary", true);
        });
      }
      this.reset();
    },
    reset() {
      this.open = false;
      this.parameters.items[0].data = "";
      this.parameters.items[1].data = "";
    },
    alert(text, color, alert) {
      this.showSnackbar = alert;
      this.textSnackbar = text;
      this.colorSnackbar = color;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 3000);
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
